import { render } from "./flowPath.vue?vue&type=template&id=b477f3a0&scoped=true&ts=true"
import script from "./flowPath.vue?vue&type=script&lang=ts"
export * from "./flowPath.vue?vue&type=script&lang=ts"

import "./flowPath.vue?vue&type=style&index=0&id=b477f3a0&lang=less&scoped=true"

import exportComponent from "D:\\test\\ieds-user-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b477f3a0"]])

export default __exports__